(function () {
  'use strict';

  angular.module('eclipseApp.core').filter('keys', function () {
    return function (input) {
      if (!input) {
        return [];
      }
      return Object.keys(input);
    };
  });

})();
